import { ContextMenuProvider } from '../context/ContextMenuContext';

export const withContextMenu = (component: () => React.ReactNode) => () =>
  <ContextMenuProvider>{component()}</ContextMenuProvider>;
